export default __webpack_public_path__ + "static/media/logo.7ca8cef2.png";